import { DAYS_CONSTANT, MONTHS_CONSTANT } from "@/constants";
import { hourAndMinuteIntToAmPm } from "@/library/helpers";
import { i18n } from "@/library/third-party/i18n";
import moment from "moment-timezone";

export function timeBasedGetText({ type = "time", values = {} }: any) {
  const { hour, minute, amPm } = hourAndMinuteIntToAmPm(values || { hour: 0, minute: 0 });
  if (type === "time") {
    values.hour = hour;
    values.minute = minute;
    values.amPm = amPm;
  }
  values.month = (values.month || 0).toString().padStart(2, "0");
  values.day = (values.day || 0).toString().padStart(2, "0");
  values.hour = (values.hour || 0).toString().padStart(2, "0");
  values.minute = (values.minute || 0).toString().padStart(2, "0");

  const forceToLeapYear = 2040;
  const momentDate = moment(`${forceToLeapYear}-${values.month}-${values.day} 00:00:00`, "YYYY-MM-DD HH:mm:ss");
  const monthLabel = MONTHS_CONSTANT[momentDate.month()];

  const texts = {
    time: `${values.hour || "..."}:${values.minute || "..."} ${values.amPm || "..."}`,
    day: DAYS_CONSTANT[values.weekday],
    date:
      i18n.locale.value == "en" ? `${momentDate.format("MMMM Do")} at ${hour}:${minute} ${amPm}` : `${Number(values.day)} ${monthLabel} ${i18n.t("at")} ${hour}:${minute} ${amPm}`,
  };
  return texts[type];
}
